import React, { useState, useEffect, useRef } from "react";
import Header from "../../dumb-components/Header";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Game.scss";

// SOUNDS
import WrongCardSound from "../../static/audio/error.mp3";
import SuccessCardSound from "../../static/audio/correct.mp3";
import check from "../../static/audio/error.mp3";
import clear from "../../static/audio/clear.mp3";
import TimeUpSound from "../../static/audio/timeup.mp3";
import LevelUpSound from "../../static/audio/level_complete.mp3";
////////

import { levelClearedModal, formatResult } from "./Helper";
import { storage } from "../../utilities/storage";

import {
  TOTAL_LEVEL,
  STARTING_LEVEL,
  STARTING_TIME,
  TIME_BONUS_PER_LEVEL,
  LIVES_BONUS_PER_LEVEL,
  INITIAL_LIVES,
} from "../../constants/GameConstants";

import BerryCard from "../../dumb-components/berryCard";
import {
  RULE_1,
  RULE_2,
  RULE_3,
  RULE_4,
  RULE_5,
  RULE_6,
  RULE_7,
  RULE_8,
  RULE_9,
  RULE_10,
} from "../../mockdata";

import {
  LEVEL_1,
  LEVEL_2,
  LEVEL_3,
  LEVEL_4,
  LEVEL_5,
  LEVEL_6,
  LEVEL_7,
  LEVEL_8,
  LEVEL_9,
  LEVEL_10,
} from "../../mockdata/levels";

import CARD_0_IMAGE from "../../static/img/cards/0.svg";
import CARD_1_IMAGE from "../../static/img/cards/1.svg";
import CARD_2_IMAGE from "../../static/img/cards/2.svg";
import CARD_3_IMAGE from "../../static/img/cards/3.svg";
import CARD_4_IMAGE from "../../static/img/cards/4.svg";
import CARD_5_IMAGE from "../../static/img/cards/5.svg";
import CARD_6_IMAGE from "../../static/img/cards/6.svg";
import CARD_7_IMAGE from "../../static/img/cards/7.svg";
import CARD_8_IMAGE from "../../static/img/cards/8.svg";
import CARD_9_IMAGE from "../../static/img/cards/9.svg";
import CARD_10_IMAGE from "../../static/img/cards/10.svg";

import solvingScript from "../../utilities/solvingScript";

const UNIQUE_BACKGROUND_COLORS = [
  "#75c366",
  "#02d7bf",
  "#ff8bab",
  "#00ade9",
  "#ff505b",
  "#ffb72e",
  "#C38D66",
  "#7033d3",
];
const UNIQUE_SHORT_BG_COLORS = [
  "#75c366",
  "#02d7bf",
  "#ff8bab",
  "#00ade9",
  "#ff505b",
  "#ffb72e",
  "#C38D66",
  "#7033d3",
];
const CARD_IMAGE_MAPPER = {
  0: CARD_0_IMAGE,
  1: CARD_1_IMAGE,
  2: CARD_2_IMAGE,
  3: CARD_3_IMAGE,
  4: CARD_4_IMAGE,
  5: CARD_5_IMAGE,
  6: CARD_6_IMAGE,
  7: CARD_7_IMAGE,
  8: CARD_8_IMAGE,
  9: CARD_9_IMAGE,
  10: CARD_10_IMAGE,
};

const LEVEL_RULE_HASH_MAP = {
  RULE_1,
  RULE_2,
  RULE_3,
  RULE_4,
  RULE_5,
  RULE_6,
  RULE_7,
  RULE_8,
  RULE_9,
  RULE_10,
};

// SELECT ALL BINARY DIGITS RULE

const imgArr = [
  {
    src: "../../static/img/restart.png",
  },
  {
    src: "../../static/img/sound.png",
  },
  {
    src: "../../static/img/music.png",
  },
];

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

const resultParams = {};
const timePerLevel = {};
let move = 0;

const Game = (props) => {
  const metadata = props.location.state;
  const gameData = storage.get.levelData();

  // card data
  const [image, setImage] = useState(imgArr);
  const [initialAudio, setAudio] = useState(false);
  const [level, setLevel] = useState(metadata.level);
  const [subLevel, setSubLevel] = useState(undefined);
  const [soundEffect, setSoundEffect] = useState(true);
  const [time, setTimer] = useState({
    minute: metadata.time.minute,
    second: metadata.time.second,
  });
  const [initialLives] = useState(metadata.lives);
  const [lives, setLives] = useState(metadata.lives);
  const [isTimerRunning, setTimerRunning] = useState(true);

  const [berryCard, setBerryCard] = useState([]);

  const [ASC_NUMBER_ARRAY, setAscNum] = useState([]);
  const [DSC_NUMBER_ARRAY, setDscNum] = useState([]);
  const [timeup, setTimeup] = useState(false);

  const [gameFinished, setGameFinished] = useState(false);

  // const [resultParams, setResultParams] = useState({});
  // const resultParams = {};

  //Sound Controllers

  const [clearSound] = useState(new Audio(clear));
  const [checkSound] = useState(new Audio(check));
  clearSound.volume = 0.5;
  checkSound.volume = 0.5;
  const [wrongCardAudio] = useState(new Audio(WrongCardSound));
  wrongCardAudio.volume = 0.9;
  // wrongCardAudio.currentTime = 0.3;
  wrongCardAudio.loop = false;

  const [successCardAudio] = useState(new Audio(SuccessCardSound));
  successCardAudio.volume = 0.9;
  successCardAudio.loop = false;
  // successCardAudio.currentTime = 0.3;

  const [levelUpAudio] = useState(new Audio(LevelUpSound));
  levelUpAudio.volume = 0.3;
  levelUpAudio.loop = false;

  const [timeUpAudio] = useState(new Audio(TimeUpSound));
  timeUpAudio.volume = 0.7;
  timeUpAudio.loop = false;
  //

  function unblockAudioEvent() {
    const sound1 = new Audio(clear);
    const sound2 = new Audio(check);
    sound1.volume = 0;
    sound2.volume = 0;

    sound1.play();
    sound2.play();

    document.removeEventListener("click", unblockAudioEvent);
    document.removeEventListener("touchstart", unblockAudioEvent);
  }

  function playSoundEvent(soundType) {
    const sound = new Audio(soundType);
    const promise = sound.play();
    if (promise !== undefined) {
      promise.then(() => { }).catch((error) => console.error);
    }
  }

  useEffect(() => {
    if (gameData && gameData.levelData.length) {
      gameData.levelData.forEach((elem) => {
        timePerLevel["level_" + elem.level] = {
          start: new Date(),
        };
      });
    }

    timePerLevel["level_" + level] = {
      start: new Date(),
    };

    if (metadata && metadata.lives) {
      setLives(metadata.lives);
    }

    if (window && window.innerWidth < 1023) {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      window.addEventListener("resize", () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      });
    }

    // POPULATING RANDOM CARDS
    generateCards();
    startStopwatch();
    // changeTimerState();
    // levelClearedModal(
    //   ModalStyle,
    //   openModal,
    //   closeModal,
    //   level,
    //   'Lorem Ipsum'
    // );
    document.addEventListener("click", unblockAudioEvent);
    document.addEventListener("touchstart", unblockAudioEvent);
  }, []);

  useEffect(() => {
    setAscNum([]);
    setDscNum([]);
    // if (level > 2 && subLevel > 2) {
    //   let possibleMove = false;
    //   let rule;
    //   if (subLevel) {
    //     rule = LEVEL_RULE_HASH_MAP["RULE_" + subLevel];
    //   } else {
    //     rule = LEVEL_RULE_HASH_MAP["RULE_" + level];
    //   }
    //   // debugger;
    //   berryCard.forEach((v) => {
    //     if (v.title && rule.validate(v)) {
    //       possibleMove = true;
    //     }
    //   });

    //   if (!possibleMove) {
    //     if (level !== TOTAL_LEVEL) {
    //       if (subLevel > 2) {
    //         setSubLevel(subLevel - 1);
    //       } else {
    //         // generateCards();
    //         levelClearedModal(
    //           ModalStyle,
    //           openModal,
    //           closeModal,
    //           level,
    //           rule.title
    //           );
    //           setSubLevel(undefined);
    //           setLevel(level + 1);
    //           setTimeout(() => generateCards(), 1);
    //       }
    //     } else {
    //       if (subLevel > 2) {
    //         return setSubLevel(subLevel - 1);
    //       }
    //     }
    //   }
    // }
  }, [level, subLevel]);

  useEffect(() => {
    if (subLevel) {
      try {
        clearSound.play();
      } catch {
        playSoundEvent(clear);
      }
    }
  }, [subLevel]);

  useEffect(() => {
    if (level > 1) {
      if (gameData && gameData.totalLevelCleared + 1 < level) {
        formatResult(resultParams, move, timePerLevel, level);
      } else if (gameData && !gameData.totalLevelCleared) {
        formatResult(resultParams, move, timePerLevel, level);
      }
    }
  }, [level]);
  useEffect(() => {
    if (gameFinished) {
      console.log("here");
      const result = formatResult(
        resultParams,
        move,
        timePerLevel,
        level,
        true
      );
      props.history.push("/game-over", { result });
    }
  }, [gameFinished]);

  useEffect(() => {
    if (isTimerRunning) {
      startStopwatch();
    }
  }, [time.minute, time.second, isTimerRunning]);

  useEffect(() => {
    if (timeup) {
      // props.history.push("/");
      // alert("Time up ho gya!!!");
      const result = formatResult(
        resultParams,
        move,
        timePerLevel,
        level,
        true,
        true
      );
      props.history.push("/game-over", { result, reason: "timeup" });
    }
  }, [timeup]);

  useEffect(() => {
    if (lives < 5 && berryCard.length > 0) {
      try {
        checkSound.play();
      } catch {
        playSoundEvent(check);
      }
      toast.warn(`You've lost a life. Follow the rule`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: "toast-dummy-id",
        theme: "dark",
      });
    }
    console.log("=======LIVES=========");
    console.log(lives);
    if (lives <= 0) {
      const result = formatResult(
        resultParams,
        move,
        timePerLevel,
        level,
        true,
        true
      );
      props.history.push("/game-over", { result, reason: "Lives finish!" });
    }
  }, [lives]);

  useEffect(() => {
    if (level > 1 && lives > 0) {
      if (!timePerLevel["level_" + (level - 1)]) {
        timePerLevel["level_" + (level - 1)] = { start: null, end: null };
        timePerLevel["level_" + (level - 1)].end = new Date();
      } else {
        timePerLevel["level_" + (level - 1)].end = new Date();
      }
      // timePerLevel["level_" + level].end = new Date();

      // timePerLevel["level_" + level] = {
      //   start: new Date(),
      // };

      // let timeobject = {
      //   ...time,
      // };

      // let newsec = timeobject.minute * 60 + timeobject.second + 30;
      // let newMinute = Math.floor(newsec / 60);
      // newsec = Math.floor(newsec % 60);

      // setTimerRunning(false);
      // setTimeout(() => {
      //   setTimer({
      //     second: newsec,
      //     minute: newMinute,
      //   });
      // }, 1000);
      // console.log(resultParams);
    }
  }, [level]);

  function startStopwatch() {
    if (isTimerRunning) {
      setTimeout(() => {
        if (time.second > 1) {
          setTimer({
            ...time,
            second: time.second - 1,
          });
        } else if (time.second === 1 && time.minute > 0) {
          setTimer({
            ...time,
            minute: time.minute - 1,
            second: 59,
          });
        } else {
          setTimer({
            ...time,
            second: 0,
          });
          setTimerRunning(false);
          setTimeup(true);
        }
      }, 1000);
    }
  }

  //////////////////////////////////

  function addMoveToGraph(item, isCorrectMove, minutes, seconds) {
    const newItem = { ...item };
    move = move + 1;
    newItem.wasCorrect = isCorrectMove;
    newItem.minute = minutes;
    newItem.second = seconds;
    newItem.level = level;
    // if (gameData && gameData.totalTimeTaken) {
    //     const timeElapsed = gameData.totalTimeTaken;
    //     newItem.time = new Date(new Date().setSeconds(new Date().getSeconds() - timeElapsed));
    // } else {
    //     newItem.time = new Date();
    // }
    newItem.time = new Date();
    resultParams["move_" + move] = newItem;
  }

  function generateCards(prefix = {}) {
    // POPULATING RANDOM CARDS
    let CARD_ARRAY = [];

    // function _generateInternal() {
    //   for (let i = 0; i < 16; i++) {
    //     let imageRandomIndex = getRandomInt(CARD_IMAGE_ARRAY.length);
    //     let bgRandomIndex = getRandomInt(8);
    let bgShortRandomIndex = getRandomInt(8);

    //     let randomNumber = getRandomInt(11);

    //     const CARD_OBJ = {
    //       number: randomNumber === 0 ? 1 : randomNumber,
    //       imgSrc: CARD_IMAGE_ARRAY[imageRandomIndex],
    //       mainbackgroundColor:
    //         prefix.mainbackgroundColor && randomNumber > 4
    //           ? prefix.mainbackgroundColor
    //           : UNIQUE_BACKGROUND_COLORS[bgRandomIndex],
    //       shortBackGroundColor: UNIQUE_SHORT_BG_COLORS[bgShortRandomIndex],
    //     };
    //     CARD_ARRAY.push(CARD_OBJ);
    //   }
    // }

    // let eligibleCards = false;
    // _generateInternal();

    // while (eligibleCards !== true) {
    //   eligibleCards = solvingScript(CARD_ARRAY, level > 3 ? 3 : level + 1);
    //   if (!eligibleCards) {
    //     CARD_ARRAY = [];
    //     _generateInternal();
    //   }
    // }

    LEVEL_1.forEach((row) => {
      row.forEach((item) =>
        CARD_ARRAY.push({
          number: item,
          shortBackGroundColor: UNIQUE_SHORT_BG_COLORS[bgShortRandomIndex],
          imgSrc: CARD_IMAGE_MAPPER[item],
        })
      );
    });

    setBerryCard(CARD_ARRAY);
  }

  //////////////////////////////////////

  function handleCardClick(item, index) {
    let rule;
    if (subLevel) {
      rule = LEVEL_RULE_HASH_MAP["RULE_" + subLevel];
    } else {
      rule = LEVEL_RULE_HASH_MAP["RULE_" + level];
    }

    if ((rule.number && rule.number === "ASC") || rule.number === "DSC") {
      if (rule.number === "ASC") {
        if (
          ASC_NUMBER_ARRAY.length &&
          ASC_NUMBER_ARRAY[ASC_NUMBER_ARRAY.length - 1] > item.number
        ) {
          let newCardArray = [...berryCard];
          newCardArray[index].shake = (newCardArray[index].shake || 1) + 1;
          setBerryCard(newCardArray);
        } else {
          let correct = true;

          for (let cardDetails of berryCard) {
            if (parseInt(cardDetails.number, 10) < item.number) {
              correct = false;
            }
          }
          if (correct) {
            let newCardArray = [...berryCard];
            newCardArray[index] = {};

            let finished = true;
            let cardFinished = true;

            for (let cardDetails of newCardArray) {
              if (cardDetails.number >= item.number) {
                finished = false;
              }
            }

            newCardArray.forEach((v) => {
              if (v.number !== undefined) {
                cardFinished = false;
              }
            });

            setBerryCard(newCardArray);
            addMoveToGraph(item, true, time.minute, time.second);
            setAscNum([...ASC_NUMBER_ARRAY, item.number]);
            if (soundEffect) {
              wrongCardAudio.pause();
              // successCardAudio.play();
            }

            if (
              finished &&
              (cardFinished || !subLevel || subLevel === 1 || level === 1)
            ) {
              return setTimeout(() => {
                if (soundEffect) {
                  successCardAudio.pause();
                  wrongCardAudio.pause();
                  // levelUpAudio.play();
                }
                if (level < TOTAL_LEVEL) {
                  // setLevel(level + 1);
                  // setSubLevel(undefined);

                  // setTimeout(() => generateCards(), 1);
                  setTimerRunning(false);
                  let wasFlawlessFinish = true;
                  for (let key in resultParams) {
                    if (resultParams[key]?.wasCorrect === false) {
                      wasFlawlessFinish = false;
                    }
                  }
                  setTimeout(
                    () =>
                      props.history.push("/level-info", {
                        resultParams,
                        level,
                        time,
                        timePerLevel,
                        wasFlawlessFinish,
                        lives,
                      }),
                    1
                  );

                  // generateCards();
                  // levelClearedModal(
                  //   ModalStyle,
                  //   openModal,
                  //   closeModal,
                  //   level,
                  //   rule.title
                  // );
                } else {
                  console.log(formatResult(resultParams, move, timePerLevel));
                  setGameFinished(true);
                }
              }, 1000);
            }
            if (finished) {
              if (subLevel) {
                setSubLevel(subLevel - 1);
              } else {
                setSubLevel(level - 1);
              }
            }
          } else {
            console.log("COMING TO ELSE BLOCK");
            setLives(lives - 1);
            let newCardArray = [...berryCard];
            newCardArray[index].shake = (newCardArray[index].shake || 1) + 1;
            addMoveToGraph(item, false, time.minute, time.second);
            if (soundEffect) {
              successCardAudio.pause();
              // wrongCardAudio.play();
            }
            setBerryCard(newCardArray);
          }
        }
      }
      // if (rule.number === "DSC") {
      //   if (
      //     DSC_NUMBER_ARRAY.length &&
      //     DSC_NUMBER_ARRAY[DSC_NUMBER_ARRAY.length - 1] < item.number
      //   ) {
      //     let newCardArray = [...berryCard];
      //     newCardArray[index].shake = (newCardArray[index].shake || 1) + 1;
      //     setBerryCard(newCardArray);
      //   } else {
      //     let correct = true;

      //     for (let cardDetails of berryCard) {
      //       if (parseInt(cardDetails.number, 10) > item.number) {
      //         correct = false;
      //       }
      //     }
      //     if (correct) {
      //       let newCardArray = [...berryCard];
      //       newCardArray[index] = {};

      //       let finished = true;
      //       let cardFinished = true;

      //       for (let cardDetails of newCardArray) {
      //         if (cardDetails.number <= item.number) {
      //           finished = false;
      //         }
      //       }

      //       addMoveToGraph(item, true, time.minute, time.second);

      //       newCardArray.forEach((v) => {
      //         if (v.number) {
      //           cardFinished = false;
      //         }
      //       });

      //       setBerryCard(newCardArray);
      //       setDscNum([...DSC_NUMBER_ARRAY, item.number]);
      //       if (soundEffect) {
      //         wrongCardAudio.pause();
      //         // successCardAudio.play();
      //       }
      //       if (
      //         finished &&
      //         (cardFinished || !subLevel || subLevel === 1 || level === 1)
      //       ) {
      //         return setTimeout(() => {
      //           if (soundEffect) {
      //             successCardAudio.pause();
      //             wrongCardAudio.pause();
      //             // levelUpAudio.play();
      //           }
      //           if (level < TOTAL_LEVEL) {
      //             setLevel(level + 1);
      //             setSubLevel(undefined);
      //             let prefixObj = {};
      //             if (level === 2) prefixObj.mainbackgroundColor = "#75c366";
      //             setTimeout(() => generateCards(prefixObj), 1);
      //             // generateCards(prefixObj);
      //             levelClearedModal(
      //               ModalStyle,
      //               openModal,
      //               closeModal,
      //               level,
      //               rule.title
      //             );
      //           } else {
      //             console.log(formatResult(resultParams, move, timePerLevel));
      //             setGameFinished(true);
      //           }
      //         }, 1000);
      //       }
      //       if (finished) {
      //         if (subLevel) {
      //           setSubLevel(subLevel - 1);
      //         } else {
      //           setSubLevel(level - 1);
      //         }
      //       }
      //     } else {
      //       let newCardArray = [...berryCard];
      //       newCardArray[index].shake = (newCardArray[index].shake || 1) + 1;
      //       addMoveToGraph(item, false, time.minute, time.second);
      //       if (soundEffect) {
      //         successCardAudio.pause();
      //         // wrongCardAudio.play();
      //       }
      //       setBerryCard(newCardArray);
      //     }
      //   }
      // }
    } else {
      if (rule.validate(item)) {
        let newCardArray = [...berryCard];

        newCardArray[index] = {};
        let finished = true;
        let cardFinished = true;

        for (let cardDetails of newCardArray) {
          if (cardDetails.number !== undefined) {
            if (rule.validate(cardDetails)) {
              finished = false;
            }
          }
        }

        newCardArray.forEach((v) => {
          if (v.number !== undefined) {
            cardFinished = false;
          }
        });

        setBerryCard(newCardArray);
        if (soundEffect) {
          wrongCardAudio.pause();
          // successCardAudio.play();
        }

        addMoveToGraph(item, true, time.minute, time.second);

        let nextLevelOrSubLevel;

        if (subLevel) {
          nextLevelOrSubLevel = subLevel - 1;
        } else {
          nextLevelOrSubLevel = level - 1;
        }

        function checkForPossibleMoves(levelForProcessing = subLevel || level) {
          if (levelForProcessing === 1) {
            nextLevelOrSubLevel = 1;
            return;
          }

          let nextRule = LEVEL_RULE_HASH_MAP["RULE_" + levelForProcessing];

          let possibleMove;

          if (nextRule) {
            possibleMove = false;
            for (let card of newCardArray) {
              if (nextRule.validate(card)) {
                possibleMove = true;
              }
            }
          }

          if (possibleMove) {
            nextLevelOrSubLevel = levelForProcessing;
            return;
          } else {
            checkForPossibleMoves(levelForProcessing - 1);
          }
        }

        checkForPossibleMoves(nextLevelOrSubLevel);

        if (finished && (cardFinished || subLevel === 1 || level === 1)) {
          return setTimeout(() => {
            if (soundEffect) {
              successCardAudio.pause();
              wrongCardAudio.pause();
              // levelUpAudio.play();
            }
            if (level < TOTAL_LEVEL) {
              // setLevel(level + 1);
              // setSubLevel(undefined);
              // generateCards();
              // setTimeout(() => generateCards(), 1);
              setTimerRunning(false);
              let wasFlawlessFinish = true;
              for (let key in resultParams) {
                if (resultParams[key]?.wasCorrect === false) {
                  wasFlawlessFinish = false;
                }
              }
              setTimeout(
                () =>
                  props.history.push("/level-info", {
                    resultParams,
                    level,
                    time,
                    timePerLevel,
                    wasFlawlessFinish,
                    lives,
                  }),
                1
              );
              // levelClearedModal(
              //   ModalStyle,
              //   openModal,
              //   closeModal,
              //   level,
              //   rule.title
              // );
            } else {
              console.log(formatResult(resultParams, move, timePerLevel));
              setGameFinished(true);
            }
          }, 1000);
        }
        if (finished) {
          setSubLevel(nextLevelOrSubLevel);
        }
      } else {
        setLives(lives - 1);
        let newCardArray = [...berryCard];
        newCardArray[index].shake = (newCardArray[index].shake || 1) + 1;
        addMoveToGraph(item, false, time.minute, time.second);
        if (soundEffect) {
          successCardAudio.pause();
          // wrongCardAudio.play();
        }
        setBerryCard(newCardArray);
      }
    }
  }

  /////////////////////////////////////
  return (
    <div className="view-game">
      <ToastContainer />
      <div className="view-game__overlay-container">
        <Header
          soundEffect={soundEffect}
          setSoundEffect={setSoundEffect}
          timeLeft={time}
          level={level}
          lives={lives}
          initialLives={initialLives}
        />

        <div className="view-game__main-container">
          <div className="view-game__main-container--level-wrapper">
            <p className="level-text">Rule {level}</p>
            <p className="description-text">
              {/* {LEVEL_RULE_HASH_MAP["RULE_" + (subLevel || level)].title} cards */}
              {!subLevel
                ? LEVEL_RULE_HASH_MAP["RULE_" + level].title
                : "Now follow rule " + subLevel}
            </p>
          </div>
          <div className="view-game__main-container--cards-wrapper">
            {berryCard &&
              berryCard.length > 0 &&
              berryCard.map((item, index) => {
                return (
                  <BerryCard
                    key={"berryCard_" + index}
                    index={index}
                    shake={item.shake}
                    number={item.number}
                    imgSrc={item.imgSrc}
                    handleClick={
                      item.number !== undefined
                        ? () => handleCardClick(item, index)
                        : undefined
                    }
                    mainbackgroundColor={item.mainbackgroundColor}
                    shortBackGroundColor={item.shortBackGroundColor}
                  />
                );
              })}
          </div>
          {/* <div className="main-content flex justify-center">
            <div className="right-content">
              <div className="menu-controls-responsive">
                <img
                  // onClick={()=>setLevel()}
                  src={require("../../static/img/restart.png")}
                  className="img-menu-control"
                  alt="Restart"
                />
                <img
                  src={require("../../static/img/sound.png")}
                  className="img-menu-control"
                  alt="Sound"
                />
                <img
                  id="button"
                  src={require("../../static/img/music.png")}
                  className="img-menu-control"
                  alt="Music"
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Game;
